import * as actionType from './type'

const INITIAL_STATE = {
    client: [],
    isLoading: false,
    error: ""
}

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case actionType.REQUEST_GET_ALL_CLIENTS: {
            return {
                ...state,
                isLoading: true
            }
        }

        case actionType.RECEIVED_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: "Please try again"
            }
        }

        case actionType.RECEIVED_ALL_CLIENTS: {
            return {
                ...state,
                isLoading: false,
                client: action.payload
            }
        }

        default: 
            return state;
    }
}